<template>
  <div class="container">
      <main>
            <Search @getInputValue='getInputValue' @search='search' @add='add'>服务记录</Search>
            <el-table
                :data="list"
                header-align="center"
                :row-class-name="TableRowClassName"
                style="width:100%;padding:0 0px;height:100%"
                :header-cell-style="{ background: '#EBEEF8',height: '45px' }"
                :cell-style="{padding:'0px'}"
            >
            <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="repairTime"
            label="报修时间"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.repairTime | timeFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="repairPerson"
            label="报修人"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="repairPersonTel"
            label="报修电话"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="deviceNo"
            label="报修设备"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="nodeName"
            label="服务网点"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="personName"
            label="服务人员"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="result"
            label="结果"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span  :style="{color:scope.row.result==0?'#F55B54':'#437ee9'}">{{scope.row.result==0?'未解决':'已解决'}}</span>
            </template>
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            fixed="right"
            min-width="80"
            width="80"
            >
                <template slot-scope="scope">
                    <div style="display:flex;width:100%;justify-content:space-around">
                        <el-button @click="edit(scope.row)" type="text" size="mini" class="btn">
                            <i class="el-icon-edit-outline" style="fontSize:19px;color:#000"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            </el-table>
            <Pagination :pageTotal="pageTotal" @currentPage="currentPage"/>
        </main>
        <el-dialog :title="isEdit?'编辑':'新增'"  :visible.sync="dialogFormVisible" center :close-on-click-modal="false" style="width:100%;margin:0 auto;marginTop:-50px">
            <div class="dialogline"></div>
            <div class="dialogdiv">
                <el-form :model="dialogForm" class="dialogForm" :rules="formRules" ref="formRules">
                    <el-form-item label="报修人员" label-width="80px" prop="repairPerson">
                        <el-input v-model="dialogForm.repairPerson" autocomplete="off" placeholder="请输入报修人" ></el-input>
                    </el-form-item>
                    <el-form-item label="报修电话" label-width="80px" prop="repairPersonTel">
                        <el-input v-model="dialogForm.repairPersonTel" autocomplete="off" placeholder="请输入报修人电话" ></el-input>
                    </el-form-item>
                    <el-form-item label="报修内容" label-width="80px" prop="repairContent">
                        <el-input v-model="dialogForm.repairContent" autocomplete="off" placeholder="请输入报修内容" ></el-input>
                    </el-form-item>
                    <el-form-item label="报修地址" label-width="80px" prop="repairAddress">
                        <el-input v-model="dialogForm.repairAddress" autocomplete="off" placeholder="请输入网点详细地址" @input="getAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="报修设备" label-width="80px" prop="deviceId" filterable >
                        <el-select  v-model="dialogForm.deviceId" filterable style="width:100%" placeholder="请选择报修设备">
                            <el-option v-for="(item,i) in deviceList" :key="i" :label="item.imei" :value='item.id'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="服务网点" label-width="80px" prop="nodeId">
                        <el-select  v-model="dialogForm.nodeId" filterable style="width:100%" @change="nodeChange" placeholder="请选择服务网点">
                            <el-option v-for="(item,i) in nodeList" :key="i" :label="item.name" :value='item.id'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="服务人员" label-width="80px" prop="personId">
                        <el-select  v-model="dialogForm.personId" filterable style="width:100%" placeholder="请先选择服务网点">
                            <el-option v-for="(item) in personList" :key="item.id" :label="item.name" :value='item.id'></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="报修结果" label-width="80px" prop="result">
                        <el-select  v-model="dialogForm.result" style="width:100%" placeholder="请选择报修结果">
                            <el-option label="未解决" value='0'></el-option>
                            <el-option label="已解决" value='1'></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="map">
                    <baidu-map
                        :center="center"
                        :zoom="zoom"
                        :scroll-wheel-zoom="true"
                        @click="getLocation"
                    >
                        <bm-view style="width: 100%; height: 29rem; flex: 1"></bm-view>
                        <bm-marker :position="markerCenter" :dragging="true" animation="BMAP_ANIMATION_DROP" @dragend='getLocation'>
                        </bm-marker>
                    </baidu-map>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmForm">{{isEdit?'保 存':'确 定'}}</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
export default {
    data(){
        return{
            option: {
                filter: '',
                pageSize: 15,
                pageIndex: 1
            },
            nodeOption:{
                filter: '',
                pageSize: 100000,
                pageIndex: 1
            },
            deviceOption:{
                filter: '',
                pageSize: 100000,
                pageIndex: 1
            },
            personOption:{
                filter: '',
                pageSize: 100000,
                pageIndex: 1
            },
            dialogForm: {
                id: 0,
                repairPerson: '',
                repairPersonTel: '',
                repairContent: '',
                repairAddress: '',
                gpsX: 0,
                gpsY: 0,
                deviceId: '',
                nodeId: '',
                personId: '',
                result: ''
            },
            center: {
                lng: 116.404,
                lat: 39.915,
            },
            zoom: 15,
            markerCenter:{
                lng: 116.404,
                lat: 39.915,
            },
            formRules:{
                repairPerson:[{
                    required: true,
                    message: "请输入报修人姓名",
                    trigger: "blur"
                }],
                repairPersonTel:[{
                    required: true,
                    message: "请输入报修人电话",
                    trigger: "blur"
                }],
                repairContent:[{
                    required: true,
                    message: "请输入报修人内容",
                    trigger: "blur"
                }],
                repairAddress:[{
                    required: true,
                    message: "请输入报修人地址",
                    trigger: "blur"
                }],
                deviceId:[{
                    required: true,
                    message: "请选择报修设备",
                    trigger: "blur"
                }],
                nodeId:[{
                    required: true,
                    message: "请选择服务网点",
                    trigger: "blur"
                }],
                personId:[{
                    required: true,
                    message: "请选择服务人员",
                    trigger: "blur"
                }],
                result:[{
                    required: true,
                    message: "请选择报修结果",
                    trigger: "blur"
                }],
            },
            defaultProps: {
                children: "children",
                label: "title",
                value:'code',
                checkStrictly: true
            },
            pageTotal: 1,
            isEdit: false,
            dialogFormVisible: false,
            list: [],
            inputValue: '',
            deviceList: [],
            personList: [],
            nodeList: [],
        }
    },
    methods:{
        //获取list
        getList(option){
            this.$api.RepairList(option).then(res=>{
                this.list = res.data.data.data;
                this.pageTotal = res.data.data.total;
            })
        },
        //获取网点列表
        getPersonNodeList(option){
            this.$api.PersonNodeList(option).then(res=>{
                this.nodeList = res.data.data.data;
            })
        },
        //获取设备列表
        getDeviceList(option){
            this.$api.DeviceList(option).then(res=>{
                this.deviceList = res.data.data.data;
            })
        },
        //获取人员列表
        // getServePerson(option){
        //     this.$api.ServeCustomerList(option).then(res=>{
        //         this.personList = res.data.data.data;
        //     })
        // },
        //获取页码
        currentPage(option){
            this.option.pageIndex = option
            this.getList(this.option);
        },
        //表格前编号
        indexMethod(index) {
            return index+1 ;
        },
        //表格隔行变色，样式在app.vue里
        TableRowClassName({row,rowIndex}){
            if(rowIndex%2 != 0){
                return 'backtablegray'
            }else{
                return 'backtablewhite'
            }
        },
        //获取搜索框值
        getInputValue(option){
            this.inputValue = option
        },
        //搜索按钮
        search(){
            this.getList({
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1
            });
        },
        //获取地址
        getAddress(){
            this.center = this.dialogForm.repairAddress;
        },
        //点击地图获取坐标
        getLocation(e){
            this.markerCenter.lng = e.point.lng;
            this.markerCenter.lat = e.point.lat;
            this.dialogForm.gpsX =  e.point.lng;
            this.dialogForm.gpsY =  e.point.lat
        },
        //服务网点改变
        nodeChange(val){
            this.$api.TheNodeCustomerList({
                id:val,
                pageSize:10000,
                pageIndex:1,
            }).then(res=>{
                this.personList = res.data.data.data;
                this.dialogForm.personId = ''
            })
        },
        //添加按钮
        add(){
            this.isEdit = false;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: 0,
                repairPerson: '',
                repairPersonTel: '',
                repairContent: '',
                repairAddress: '',
                gpsX: 0,
                gpsY: 0,
                deviceId: '',
                nodeId: '',
                personId: '',
                result: ''
            };
            this.center = {
                lng: 116.404,
                lat: 39.915,
            }
            this.markerCenter = {
                lng: 116.404,
                lat: 39.915,
            }
        },
        //编辑按钮
        edit(row) {
            this.isEdit = true;
            this.dialogFormVisible = true;
            this.$api.TheNodeCustomerList({
                id: row.nodeId,
                pageSize:10000,
                pageIndex:1,
            }).then(res=>{
                this.personList = res.data.data.data;
                this.dialogForm = {
                    id: row.id,
                    repairPerson: row.repairPerson,
                    repairPersonTel: row.repairPersonTel,
                    repairContent: row.repairContent,
                    repairAddress: row.repairAddress,
                    gpsX: row.gpsX,
                    gpsY: row.gpsY,
                    deviceId: row.deviceId,
                    nodeId: String(row.nodeId),
                    personId: row.personId,
                    result: String(row.result)
                };
                this.center = {
                    lng: row.gpsX,
                    lat: row.gpsY,
                }
                this.markerCenter = {
                    lng: row.gpsX,
                    lat: row.gpsY,
                }
            })
        },
        //dialog提交按钮
        confirmForm(){
            this.$refs.formRules.validate(valid=>{
                if(valid){
                    //可以提交
                    this.dialogForm.nodeId = Number(this.dialogForm.nodeId);
                    this.dialogForm.result = Number(this.dialogForm.result);
                    this.dialogForm.deviceId = Number(this.dialogForm.deviceId);
                    this.dialogForm.personId = Number(this.dialogForm.personId);
                    if(this.isEdit){
                        this.$api.UpdateRepair(this.dialogForm).then(res=>{
                            if(res.data.code == 200){
                                this.getList(this.option);
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    message: res.data.msg,
                                    type: 'error'
                                })
                            }
                        });
                        this.dialogFormVisible = false;
                    }else{
                        if(this.dialogForm.gpsX==0 || this.dialogForm.gpsY==0){
                            this.$message({
                                message: '请在地图上打点！',
                                type: 'warning'
                            });
                        }else{
                            this.$api.AddRepair(this.dialogForm).then(res=>{
                                if(res.data.code == 200){
                                    this.getList(this.option);
                                    this.$notify({
                                        message: res.data.msg,
                                        type: 'success'
                                    })
                                }else{
                                    this.$notify({
                                        message: res.data.msg,
                                        type: 'error'
                                    })
                                }
                            });
                            this.dialogFormVisible = false;
                        }
                    }
                }else{
                    return false
                }
            })
        }
    },
    mounted(){
        this.getList(this.option);
        this.getPersonNodeList(this.nodeOption);
        // this.getServePerson(this.personOption);
        this.getDeviceList(this.deviceOption)
    }
}
</script>

<style lang='scss' scoped>
.container{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
main{
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 8px;
}
.dialogdiv{
    display: flex;
    justify-content: space-between;
    height: 29rem;
    width: 100%;
    .el-form{
        width: 46%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom: 0;
        border-right:1px solid #ccc;
        padding-right: 20px;
    }
    .map{
        width: 52%;
        height: 29rem;
    }
}
</style>